export default "__VITE_ASSET__C$6xJkVu__$_?inline__"